<template>
    <v-row class="mx-1 mt-8">
        <v-col v-if="showTable" cols="12" align-self="center" >
            <v-sheet :class="xs?'card-dialogs-graph-wop':'card-dialogs-graph'" class="mb-4 text-center card-container-table" color="bgtopology">
                <h4 class="py-3"> {{ t('title.tableTitle') }} </h4>
                <v-sheet v-if="arrayTable.length !== 0" height="354" color="transparent" class="pt-10">
                    
                    <EasyDataTable
                    v-if="arrayTable.length > 0"
                    table-class-name="customize-table"
                    show-index
                    :headers="finalHeader"
                    :items="arrayTable"
                    :rows-per-page="10"
                    :body-row-class-name="bodyRowClass"
                    hide-footer
                    >
                    </EasyDataTable>
                </v-sheet>
                <v-sheet v-else class="text-center" color="transparent">
                    <Prog_circular />
                </v-sheet>
            </v-sheet>            
        </v-col>
    </v-row>
</template>

<script setup lang="ts">
import { onMounted, ref, Ref } from 'vue';

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
const { xs } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

/********************************
 ********** COMPONENTS **********
 *******************************/
import Prog_circular    from '@/components/PrincipalComponents/Prog_circular.vue';

/********************************
 ********** CONSTANTES **********
 *******************************/
import { FINAL_HEADERS_TABLE } from '@/constants/tableHeaders';
import { LABELS } from '@/constants/labels';

/********************************
 ********** INTERFACES **********
 *******************************/
import { STRINGS } from '@/interfaces/SmartLink/General';
import { PMPAP } from '@/interfaces/SmartLink/Graphs';
type BodyRowClassNameFunction = (item: STRINGS, rowIndex: number) => string;

/********************************
 *********** SERVICES ***********
 *******************************/
import { getStatusTable } from '@/services/Smartlink/Graphs';

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
const store = useStore();

// Definir el tipo para la función de clases de fila

const props = defineProps({
    title   : { required:true },
    ip      : { required:true, type:String },
})


const arrayTable:Ref<PMPAP[]>       = ref([]);
const showTable                     = ref(true);

const params = { ip : props.ip }

/**
 * Captura los valores de la API: "getTableTopologyData"
 * envía como parámetro la IP
 */
async function getDataTable() {

    const allData = await getStatusTable(params)

    if( allData.status === 400 ){
        showTable.value = allData.showGraphs
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        showTable.value = allData.showGraphs
        arrayTable.value = allData.data
    }
}


const bodyRowClass : BodyRowClassNameFunction = (item:STRINGS):string =>{
    if(item.status.toUpperCase() === 'ALARM')  return 'alarm-design'
    if(item.status.toUpperCase() === 'ALERT')  return 'alert-design'
    return 'normal-design'
}


const header        = FINAL_HEADERS_TABLE['status'];
const finalHeader   = ref(header)

onMounted(() => {
    getDataTable();
})

</script>

<style>

.card-container-table{
    height: 100% !important;
    min-height: 100% !important;
}

 .card-dialogs-graph{
    padding: 20px;
    border-radius: 10px;
 }

 .card-dialogs-graph-wop{
    padding:5px;
    border-radius: 10px;
 }

 .highcharts-root{
    border-radius: 20px;
 }

 .vue3-easy-data-table__footer{
    background-color: transparent !important;
    color: rgb(var(--v-theme-colorText)) !important;
    border-top: none !important;
 }

 .easy-data-table__rows-selector ul.select-items li{
    color: black ;
 }

 .easy-data-table__rows-selector .rows-input__wrapper{
    border-bottom: 1px solid rgb(var(--v-theme-colorText)) !important;
 }

 .easy-data-table__rows-selector .rows-input__wrapper .triangle{
    border-top: solid 6px rgb(var(--v-theme-colorText)) !important;
 }

 .alert-design {
    --easy-table-body-row-background-color: #fafad2;
    --easy-table-body-even-row-background-color: #fafad2;
    color: black !important;
}

.alarm-design{
    --easy-table-body-row-background-color: #eecaca;
    --easy-table-body-even-row-background-color: #eecaca;
    color: black !important;
}

</style>